export default __webpack_public_path__ + "static/logo-086ec67053e8c2873d645a6b776c2272.svg";